import { observable, action, makeObservable, runInAction } from 'mobx';
import {
    getQuestionInfo,
    getCompetitionTitle,
    getCompetitionPlanInfo,
    getWorksList,
    addWorkName,
    deleteWork,
    updateWorkList,
    getOpenCompetitionInfoApi,
    getWorkCollectionDetailApi,
    getStudentCompeteInfoAndCheckApi,
    getStudentCompeteInfoApi,
    updateStudentCompeteInfoApi,
    getIsShowFieldApi,
    getPrizeResultConfigApi,
    getStudentPrizeResultApi,
    submitWorksApi
} from '@/api/competition';
import { RequestResult } from '@/api/requestType';
import message from '@/components/Toast';
import { competition_constants } from '@/utils/constants';


class Competition {
    constructor() {
        makeObservable(this);
    }

    @observable business_id = '';

    @action
    setBusinessId = (v) => {
        this.business_id = v;
    };

    //作品名称弹窗
    @observable workModalVisible = false;

    @action
    setWorkModalVisible = (v) => {
        this.workModalVisible = v;
    };

    //协议弹窗
    @observable protocolRecordModalVisible = false;
    @action
    setProtocolRecordModalVisible = (v) => {
        this.protocolRecordModalVisible = v;
    };

    //市级线上活动展示结束弹窗
    @observable cityWorkShowOverVisible = false;
    @action
    setCityWorkShowOverVisible = (v) => {
        this.cityWorkShowOverVisible = v;
    };

    //问卷弹窗
    @observable questionModalVisible = false;
    //当前问卷index
    @observable currentQuestionnaireIndex = -1;
    //问卷索引数组
    @observable requiredQuestionnaireIndices: number[] = [];

    @observable questionList = [];
    //问卷信息 - 是否有问卷
    getQuestionInfo = async (params) => {
        const res: RequestResult = await getQuestionInfo(params);

        if (res.code === '00000') {
            runInAction(() => {
                this.requiredQuestionnaireIndices = [];
                if (res.data.length) {
                    this.questionList = res.data;
                    for (let i = 0; i < res.data?.length; i++) {
                        const item = res.data[i];
                        if (
                            item?.required === 1 ||
                            (item?.required === 2 && item?.pop_number === 1) ||
                            (item?.required === 2 && item?.pop_number === 2 && item?.pop_status !== 1)
                        ) {
                            this.requiredQuestionnaireIndices.push(i);
                        }
                    }
                    if (this.requiredQuestionnaireIndices.length > 0) {
                        this.currentQuestionnaireIndex = this.requiredQuestionnaireIndices[0];
                        this.questionModalVisible = true;
                    }
                } else {
                    this.questionList = [];
                }
            });
        } else {
            return message.error(res.msg);
        }
    };

    //显示下一个问卷弹窗
    showNextQuestionnaire = () => {
        if (!this.requiredQuestionnaireIndices.length) return;
        const currentPosition = this.requiredQuestionnaireIndices.indexOf(this.currentQuestionnaireIndex);
        if (currentPosition < this.requiredQuestionnaireIndices.length - 1) {
            this.currentQuestionnaireIndex = this.requiredQuestionnaireIndices[currentPosition + 1];
            this.questionModalVisible = true;
        } else {
            this.requiredQuestionnaireIndices = [];
            this.currentQuestionnaireIndex = -1;
            this.questionModalVisible = false;
        }
    };

    @action
    setQuestionModalVisible = (v, isFinish = false) => {
        this.questionModalVisible = v;
        if (isFinish) return;
        if (!v) {
            setTimeout(() => {
                this.showNextQuestionnaire();
            }, 300);
        }
    };

    @observable competitionPlanInfo = [
        {
            stage_id: '1',
            work_info: {
                works_list: [
                    {
                        item_id: '123',
                        status: '',
                        percent: 0
                    }
                ],
                is_edit_work_List: false
            }
        }
    ];

    @observable competitionPlanName = '';
    @observable competitionPlanId = '';
    @observable version = '';

    @action
    setCompetitionPlanInfo = (v, item_index, item_work_index) => {
        const competitionPlanInfo_item_index = this.competitionPlanInfo[item_index],
            competitionPlanInfo_item_work_index = Object.assign(competitionPlanInfo_item_index.work_info?.works_list[item_work_index], {
                status: 'active',
                percent: Math.floor(v * 100)
            });
        //是否修改了列表数据 用于判断提交按钮
        competitionPlanInfo_item_index.work_info.is_edit_work_List = true;
        competitionPlanInfo_item_index.work_info?.works_list?.splice(item_work_index, 1, competitionPlanInfo_item_work_index);
        this.competitionPlanInfo.splice(item_index, 1, competitionPlanInfo_item_index);
    };

    //查询赛程和分组
    getCompetitionPlanInfo = async (params) => {
        const res: RequestResult = await getCompetitionPlanInfo(params);

        if (res.code === '00000') {
            runInAction(async () => {
                this.competitionPlanName = res.data?.plan_name;
                this.competitionPlanInfo = res.data?.stage_list;
                this.competitionPlanId = res.data?.plan_id;
                this.version = res.data?.version;
                await this.getQuestionInfo({
                    business_id: this.business_id,
                    template_id: competition_constants.template_id,
                    plan_id: res.data?.plan_id
                });

                res.data?.stage_list?.forEach(async (element, index) => {
                    await this.getWorksList(
                        {
                            activity_id: element.activity_id,
                            plan_id: this.competitionPlanId,
                            stage_id: element.stage_id,
                            business_id: this.business_id,
                            version: element.version
                        },
                        index
                    );
                });
            });
        } else {
            return message.error(res.msg);
        }
    };

    getWorksList = async (params, index) => {
        const res: RequestResult = await getWorksList(params);

        if (res.code === '00000') {
            res.data?.works_list.forEach((item) => {
                item.percent = 0;
                item.status = 'normal';
            });
            runInAction(() => {
                const competitionPlanInfo = this.competitionPlanInfo;
                competitionPlanInfo[index].work_info = res.data;
                this.competitionPlanInfo = [...competitionPlanInfo];
            });
        } else {
            return message.error(res.msg);
        }
    };

    @observable competitionTitle = '';
    //查询大赛详情
    getCompetitionTitle = async (params) => {
        const res: RequestResult = await getCompetitionTitle(params);

        if (res.code === '00000') {
            runInAction(() => {
                this.competitionTitle = res.data;
            });
        } else {
            return message.error(res.msg);
        }
    };

    @observable editStage = {
        id: 'string',
        business_id: 0,
        plan_id: 0,
        version: 'string',
        stage_id: 0,
        activity_id: 0,
        works_name: 'string'
    };

    @action
    setEditStage = (v) => {
        this.editStage = v;
    };

    addWorkName = async (params, item_index) => {
        const res: RequestResult = await addWorkName(params);

        if (res.code === '00000') {
            await this.getWorksList(
                {
                    activity_id: this.editStage?.activity_id,
                    plan_id: this.competitionPlanId,
                    stage_id: this.editStage?.stage_id,
                    business_id: this.business_id,
                    version: this.editStage?.version
                },
                item_index
            );
        } else {
            return message.error(res.msg);
        }
    };

    updateWorkList = async (params, item, item_index) => {
        const res: RequestResult = await updateWorkList(params);

        if (res.code === '00000') {
            await this.getWorksList(
                {
                    activity_id: item.activity_id,
                    plan_id: this.competitionPlanId,
                    stage_id: item.stage_id,
                    business_id: this.business_id,
                    version: item.version
                },
                item_index
            );
        } else {
            return message.error(res.msg);
        }
    };

    deleteWork = async (params, item, item_index) => {
        const res: RequestResult = await deleteWork(params);

        if (res.code === '00000') {
            await this.getWorksList(
                {
                    activity_id: item.activity_id,
                    plan_id: this.competitionPlanId,
                    stage_id: item.stage_id,
                    business_id: this.business_id,
                    version: item.version
                },
                item_index
            );
        } else {
            return message.error(res.msg);
        }
    };

    @observable competitionInfo = {};

    @action
    setCompetitionInfo = (v) => {
        this.competitionInfo = Object.assign({}, this.competitionInfo, v);
    };
    //不需要登录公开查询大赛名称
    getOpenCompetitionTitle = async (params) => {
        const res: RequestResult = await getOpenCompetitionInfoApi(params);

        if (res.code === '00000') {
            runInAction(() => {
                this.competitionTitle = res.data?.title;
                this.setCompetitionInfo(res.data);
            });
        } else {
            return message.error(res.msg);
        }
    };

    @observable showRuleInfo = {};

    @action
    setShowRuleInfo = (v) => {
        this.showRuleInfo = Object.assign({}, this.showRuleInfo, v);
    };

    @observable workCollectionInfo = {};
    @action
    setWorkCollectionInfo = (v) => {
        this.workCollectionInfo = Object.assign({}, this.workCollectionInfo, v);
    };

    @observable workCollectionResult = {};
    @action
    setWorkCollectionResult = (v) => {
        this.workCollectionResult = Object.assign({}, this.workCollectionResult, v);
    };

    // 大赛作品集展示 查询展示详情接口
    getWorkCollectionDetail = async (params) => {
        const res: RequestResult = await getWorkCollectionDetailApi(params);
        if (res.code === '00000') {
            runInAction(() => {
                this.setWorkCollectionInfo(res.data || {});
            });
        }
        this.setWorkCollectionResult(res);
    };

    // 作品展示作品集选中的展示的作品
    @observable checkedShowWork = {};
    @action
    setCheckedShowWork = (v) => {
        this.checkedShowWork = Object.assign({}, this.checkedShowWork, v);
    };

    // 学员参赛信息
    @observable studentCompeteInfo = {};
    @action
    setStudentCompeteInfo = (v) => {
        this.studentCompeteInfo = Object.assign({}, this.studentCompeteInfo, v);
    };
    //查询大赛详情
    getStudentCompeteInfo = async (params) => {
        const res: RequestResult = await getStudentCompeteInfoAndCheckApi(params);
        if (res.code === '00000') {
            runInAction(() => {
                if (res.data?.config?.length) {
                    this.setStudentCompeteInfoModalVisible(true);
                }
                this.setStudentCompeteInfo(res.data);
            });
        } else {
            return message.error(res.msg);
        }
    };

    //完善参赛信息弹窗
    @observable studentCompeteInfoModalVisible = false;
    @action
    setStudentCompeteInfoModalVisible = (v) => {
        this.studentCompeteInfoModalVisible = v;
    };
    updateStudentCompeteInfo = async (params) => {
        const res: RequestResult = await updateStudentCompeteInfoApi(params);
        if (res.code === '00000') {
            message.success('操作成功');
            this.setStudentCompeteInfoModalVisible(false);
        } else {
            return message.error(res.msg);
        }
    };
    //点击查看信息按钮查询参赛信息不需要验证是否必填
    viewCompeteInfo = async (params) => {
        const res: RequestResult = await getStudentCompeteInfoApi(params);
        if (res.code === '00000') {
            runInAction(() => {
                if (res.data?.config?.length) {
                    this.setStudentCompeteInfoModalVisible(true);
                }
                this.setStudentCompeteInfo(res.data);
            });
        } else {
            return message.error(res.msg);
        }
    };

    @observable isShowHeaderInfoBtn = false;
    // 查询是否有需要展示的大赛字段
    getIsShowField = async (params) => {
        const res: RequestResult = await getIsShowFieldApi(params);
        if (res.code === '00000') {
            this.isShowHeaderInfoBtn = res.success;
        }
    };

    @observable prizeResultConfig = {};
    @action
    setPrizeResultConfig = (v) => {
        this.prizeResultConfig = Object.assign({}, this.prizeResultConfig, v);
    };
    // 大赛查询成果奖项配置
    getPrizeResultConfig = async (params) => {
        const res: RequestResult = await getPrizeResultConfigApi(params);
        if (res.code === '00000') {
            runInAction(() => {
                this.setPrizeResultConfig(res.data || {});
            });
        }
    };

    @observable studentPrizeResult = {};
    @action
    setStudentPrizeResult = (v) => {
        this.studentPrizeResult = Object.assign({}, this.studentPrizeResult, v);
    };

    @observable certificateList = [];
    @action
    setCertificateList = async (listData, defaultId?: string) => {
        let defaultSelect = listData[0];
        for (let i = 0, len = listData.length; i < len; i++) {
            if (defaultId && defaultId === listData[i].id) {
                defaultSelect = listData[i];
            }
        }
        this.setCurrentShowCertificate(defaultSelect);
        this.certificateList = listData;
    };
    // 大赛查询成果数据
    getStudentPrizeResult = async (params, defaultId?: string) => {
        const res: RequestResult = await getStudentPrizeResultApi(params);
        if (res.code === '00000') {
            this.setCertificateList(res.data?.certificate_list || [], defaultId).then(() => {});
            this.setStudentPrizeResult(res.data || {});
        }
    };

    @observable currentShowCertificate = {};
    @action
    setCurrentShowCertificate = (v) => {
        this.currentShowCertificate = Object.assign({}, this.currentShowCertificate, v);
    };
    // 提交赛程作品
    submitWorks = async (data, item, item_index) => {
        const res: RequestResult = await submitWorksApi(data);
        if (res.code === '00000') {
            message.success('作品材料提交成功');
            await this.getWorksList(
                {
                    activity_id: item.activity_id,
                    plan_id: this.competitionPlanId,
                    stage_id: item.stage_id,
                    business_id: this.business_id,
                    version: item.version
                },
                item_index
            );
        } else {
            message.error(res.msg || '操作失败');
        }
    };
}

export default new Competition();
